/* global http formHelper reservationHelper ga preloader scrollOnEvent */
const submitReservation = {
	el: {
		html: document.documentElement,
		body: document.body,
		formReservation: document.querySelector('.js-form-reservation'),
		selects: document.querySelectorAll('.form-table__select select'),
		inputBookingId: document.querySelector('.js-booking-id')
	},

	vars: {
		bookingLines: [],
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxSubmitReservation(el) {
		// check if element exists
		if (!el) return

		// get endpoint
		const endpoint = el.getAttribute('data-action'),
			section = el.closest('.form')

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		//add bookingLines to data
		const BookingLines = this.vars.bookingLines
		const formData = formHelper.fxFormToJson(section),
			data = {
				BookingLines,
				...formData
			}

		if (this.vars.extraLargeAndUp.matches === false) {
			data.ratePlan = '0'
		}

		const callback = (response, data) => {
			preloader.fxPreloaderRemove(section)
			scrollOnEvent.fxScrollOnEvent(document.querySelector('.content-aside'))

			//update input booking ID
			const bookingId = this.el.inputBookingId.value = data.bookingId

			if (response.status === 200) {
				//events google analytics
				if (window.ga && ga.loaded)
					ga('send', 'event', { 'eventCategory': 'booking', 'eventAction': 'click', 'eventLabel': 'step3', 'eventValue': 1 })

				if (data.isError) {
					switch (data.statusCode) {
						// cartao jovem invalid
						case 222: {
							const form = document.querySelector('[name="numCartaoJovemReservations"]') && document.querySelector('[name="numCartaoJovemReservations"]').parentElement,
								div = document.createElement('div')

							div.classList.add('form__error-message', 'form__error-message-card-invalid')
							form.appendChild(div)
							document.querySelector('.form__error-message-card-invalid').textContent = ''
							document.querySelector('.form__error-message-card-invalid').textContent = data.message
							document.querySelectorAll('.form__error-message-card-invalid').length > 1 && document.querySelectorAll('.form__error-message-card-invalid:not(:first-of-type)').forEach(el => el.remove())
							break
						}
					}
				}

				else {
					switch (data.statusCode) {
						// if free voucher
						case 201: {
							const confirmReservationUrl = el.closest('.js-form-reservation').dataset.actionConfirmReservation,
								reservationUrlWithParameters = `${confirmReservationUrl}?id=${bookingId}`

							location.href = reservationUrlWithParameters
							break
						}

						// if no error, go to section 3 of reservation form
						default: {
							reservationHelper.fxLoopElements(document.querySelectorAll('.form__tab'), 'section', el.dataset.sectionNext)
							break
						}
					}
				}
			}
		}
		preloader.fxPreloaderAdd(section)
		http.fxPost(endpoint, data, callback, languageParameter)
	},

	//fx to update bookings
	fxTriggerEvents() {
		const selects = document.querySelectorAll('.form-table__select select'),
			inputRateplan = document.querySelectorAll('.form-table__radio-input')

		selects.forEach(el => el.addEventListener('change', () => this.fxUpdateBookingLines()))
		inputRateplan.forEach(el => el.addEventListener('change', () => this.fxUpdateBookingLines()))
	},

	fxUpdateBookingLines() {
		const selects = document.querySelectorAll('.form-table__select select')

		let bookingLines = [],
			ratePlanValue = null,
			field = {}

		//get rateplan
		if (this.vars.extraLargeAndUp.matches) {
			document.querySelectorAll('.form-table--desktop .form-table__radio-input').forEach(input => input.checked ? ratePlanValue = input.value : '')
		}
		
		else {
			document.querySelectorAll('.form-table--mobile .form-table__radio-input').forEach(input => input.checked ? ratePlanValue = input.value : '')
		}

		document.querySelector('.js-rateplan').value = ratePlanValue
		console.log(ratePlanValue, document.querySelector('.js-rateplan').value)
		
		//loop selects/inputs
		selects.forEach(item => {
			if (item.value !== '0') {

				const wrapper = item.closest('.js-room-info')

				wrapper.querySelectorAll('.js-rateplan-value').forEach(el => {
					if (ratePlanValue === el.dataset.rateplan) {
						field = {
							'RoomID': Number(wrapper.dataset.roomId),
							'RoomDescription': wrapper.dataset.roomDescription,
							'CodTipologia': wrapper.dataset.roomTypology,
							'NumberOfUnits': Number(item.value),
							'GuestCount': Number(wrapper.dataset.roomCapacity),
							'StartDate': this.el.formReservation.querySelector('.js-start-date').value,
							'EndDate': this.el.formReservation.querySelector('.js-end-date').value,
							'ResourceAmountAfterTax': item.value * el.dataset.price
						}
					}
				})

				bookingLines.push(field)
			}
		})
		this.vars.bookingLines = bookingLines
	},

	init() {
		this.el.formReservation && this.fxTriggerEvents()
	}
}

submitReservation.init()
